import React, { Component } from 'react';
import { Row, Col } from 'react-bootstrap';
import Navbar from '../header-footer/nav';
import MovieItem from './movie_item.jsx';
import { connect } from "react-redux";
import { GetMoviesHome } from '../Redux/action';
import Carousels from './carousels';
import MoviesItemSkeletion from './moviesItemSkeletion';
class Home extends Component {
    componentDidMount() {
        this.props.GetMoviesHome();
    }
    render() {
        const IndexSt = Array.from({ length: 20 });
        const Movie = this.props.MovieHome.Movie.movies;
        return (
                <div className="container mt-5">
                    <div className="row">
                        <div className="home-navbar col-sm-12 col-md-3 col-lg-3 col-xxl-3">
                            <div className="sticky-md-top sticky-lg-top sticky-xl-top">
                                <div className="d-md-flex align-items-center d-none d-md-block justify-content-between my-4 pb-1 w-100">
                                    <h4 className="font-size-24 font-weight-medium m-0">Explore</h4>
                                </div>
                                <div className="d-none d-sm-block">
                                    <Navbar />
                                </div>
                            </div>
                        </div>
                        <div className="home-body-item col-sm-12 col-md-9 col-lg-9 col-xxl-9">
                            <Carousels />
                            <div className="d-md-flex align-items-center justify-content-between my-4 pb-1 w-100">
                                <h4 className="font-size-24 font-weight-medium m-0">Trending Movies&nbsp;</h4>
                                <div className="d-none d-md-block border-top-theme col p-0 mt-2 border-gray-6830"></div>
                            </div>
                            <Row className="mt-3 container-card">
                                {
                                    Movie && Movie ?
                                        <>
                                            {
                                                Movie && Movie.map((Movies, index) => {
                                                    return (
                                                        <Col xs={6} md={3} key={index} className="px-2">
                                                            <MovieItem {...Movies} />
                                                        </Col>
                                                    )
                                                })
                                            }
                                        </> :
                                        <Row className="mt-3 container-card">
                                            {
                                                IndexSt && IndexSt.map((index) => {
                                                    return (
                                                        <Col xs={6} md={3} key={index} >
                                                            <MoviesItemSkeletion />
                                                        </Col>
                                                    )
                                                })
                                            }
                                        </Row>
                                }
                            </Row>
                        </div>
                    </div>
                </div>
        );
    }
}
const mapStateToProps = (state) => {
    return {
        MovieHome: state.MovieHomePage,
    }
}

export default connect(mapStateToProps, { GetMoviesHome })(Home);